var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 48,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#weight_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#4F5171",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M32.482 16.029c1.621.027 3.496-.45 3.423 2.275-.14 5.717 2.13 11.918-3.45 16.206.409 4.469.784 8.643 1.166 12.81M13.688 29.172c0 1.16.074-1.128 0 0m0 0c-.255 3.966 3.851 5.435 6.27 7.663-.416 3.617-.804 7.053-1.2 10.489"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M25.67.669v7.965z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4F5171",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M25.67.669v7.965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M14.833 2.506c1.327 2.302 2.653 4.597 3.979 6.899z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4F5171",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.833 2.506c1.327 2.302 2.653 4.597 3.979 6.899"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M35.543 2.506c-1.326 2.302-2.652 4.597-3.978 6.899z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4F5171",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M35.543 2.506c-1.326 2.302-2.652 4.597-3.978 6.899M21.13 14.894c-.952.154-2.05-.41-3.41 1.14v10.818c-.83 1.174-2.866 1.805-4.032 2.322M26.803 17.738c-.215-1.637 1.064-4.013-2.271-4.013s-2.056 2.376-2.27 4.013M27.941 14.898c3.128-.383 4.113 1.073 3.41 3.986M8.035 12.95H4.552v25.889h3.483zM3.97 17.025H.486v17.75h3.482zM42.382 38.838h3.483v-25.89h-3.483zM46.447 34.769h3.483v-17.75h-3.483zM8.035 23.144h9.685M37.144 23.144h5.238M37.144 27.175h5.238M8.035 27.175h9.37"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "weight_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.2 0h50.4v48H.2z"
})))));
export { SvgWeight as ReactComponent };
export default __webpack_public_path__ + "ba171b9e2c08061ca13727ae9221a7b3.svg";